"use client";
import { useEffect, useState } from "react";
import Image from "next/image";


import AnimatedText from "@/components/common/AnimatedText";
// import { faqs } from "@/data/faq";
export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const fetchContactus = async () => {
      try {
        const response = await fetch('/api/contactus');
        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            setEmail(data[0].email);
          }
        }
      } catch (error) {
        console.error('Failed to fetch Contact Us:', error);
      }
    };

    const fetchFaqs = async () => {
      try {
        const response = await fetch('/api/faqs');
        if (response.ok) {
          const data = await response.json();
          setFaqs(data);
        }
      } catch (error) {
        console.error('Failed to fetch Faqs:', error);
      }
    };

    fetchContactus();
    fetchFaqs();
  }, []);



  return (
    <section className="faq-section">
      <div className="container">
        <div className="row faq-row">

          {/* LEFT SIDE */}
          <div className="col-lg-5">
            <div className="faq-left">

              <div className="faq-mini-title">
                <span className="faq-dot"></span>
                Frequently Asked Questions
              </div>

              <h2 className="faq-title">
                Find answers to <br />
                frequently asked <br />
                questions
              </h2>

              <p className="faq-desc">
                Browse through some common questions people ask.
              </p>

              {/* Help Box */}
              <div className="faq-help-box">
                <div className="px-5 pt-4">
                  <h4>Need Any Help? We're Here To Guide You!</h4>
                  <p>Still have questions? We're here to help you!</p>
                </div>
                <div className="faq-email">
                  <span className="faq-email-icon">
                    ✉
                  </span>
                  Email Us: {email}
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7">
            <div className="faq-right">

              <div className="accordion" id="accordion">
                {faqs.map((faq, index) => (
                  <div
                    key={faq._id || index}
                    className="accordion-item faq-accordion-item mb-4"
                  >

                    <h5 className="accordion-header">
                      <button
                        onClick={() => {
                          console.log("clicked", index)
                        }}
                        className={`accordion-button faq-accordion-button ${index === 0 ? "" : "collapsed"
                          }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#faq-${faq._id}`}
                        aria-expanded={index === 0 ? "true" : "false"}
                        aria-controls={`faq-${faq._id}`}
                      >
                        {faq.question}
                      </button>
                    </h5>

                    <div
                      id={`faq-${faq._id}`}
                      className={`accordion-collapse collapse
                       ${index === 0 ? "show" : ""
                        }`}
                      data-bs-parent="#accordion"
                    >
                      <div className="accordion-body faq-accordion-body">
                        {faq.answer}
                      </div>
                    </div>

                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
